<template>
  <div class="d-flex flex-column modal-content col-6 fs-5 align-items-center p-0">
    <div class="d-flex justify-content-between w-100 modal-header">
      <div></div>
      <h3 class="fs-3 fw-bold">Something went wrong with logging you.</h3>
      <button class="btn btn-gray btn-xl" @click="close">
        <i class="fa fa-close"></i>
      </button>
    </div>
    <div class="modal-body d-flex flex-column">
      <p v-if="accounts.length > 1">These are the email accounts you are logged in with:</p>
      <p v-else>This is the email account your are logged in with:</p>
      <p v-for="account in accounts" :key="account.username">{{ account.username }}</p>
      <p>
        Our records indicate that there are no CrimeTime accounts linked to this Microsoft
        account.
      </p>
      <p>Here are steps to address this issue:</p>
      <ol>
        <li>
          Log in to your CrimeTime account with your Email Address and Password, then on the
          "My Account" page, under Account Management, click on the Microsoft Sign In button
          to link your CrimeTime account to your Microsoft account
        </li>
        <li>
          If you have already done step 1, your browser may be logged in to the wrong
          Microsoft account. Click the Log Out button below to sign out of your Microsoft
          Acccount. If you are signed in to multiple Microsoft accounts, you may need to
          close this window, log back in with Microsoft by clicking on the Sign in button,
          and repeat this step.
        </li>
  
        <li>Refresh the page, or try closing out your browser window.</li>
        <li>
          If none of these work, you may need to manually sign out of your Microsoft
          accounts, clear your cookies and site data, or open an incognito window and try
          again.
        </li>
        <li>For additional support, you can <a href="https://placergroup.com/contact" target="_blank">contact us</a> for troubleshooting assistance.</li>
      </ol>
      <div class="ta-c">
        <button class="btn btn-primary btn-xl" @click="microsoftLogOut">Log Out</button></div>
    </div>
    
  </div>
</template>
<script>
import { PublicClientApplication } from "@azure/msal-browser";
export default {
  name: "MicrosoftErrorModal",
  props: ["me"],
  data() {
    return {
      msal: null,
      accounts: [],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async microsoftLogOut() {
      this.msal.logoutPopup();
    },
  },
  async mounted() {
    const msalConfig = {
      auth: {
        clientId: process.env.VUE_APP_OFFICE_365_SSO_APP_ID,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: `${process.env.VUE_APP_URL}/MicrosoftLoginRedirect`,
      },
      cache: {
        cacheLocation: "localStorage",
      },
      redirectUri: `${process.env.VUE_APP_URL}/`,
    };
    this.msal = new PublicClientApplication(msalConfig);
    await this.msal.initialize();
    this.accounts = this.msal.getAllAccounts();
  },
};
</script>
<style scoped>
a {
    color: var(--button) !important;
    text-decoration: underline;
    font-weight: 500 !important;
}

</style>
